<!--
 * @Author: lixiaodi
 * @Date: 2020-03-13 09:21:21
 * @LastEditors: lixiaodi
 * @LastEditTime: 2020-06-24 11:01:44
 -->
 <template>
    <div class="share-box">
        <!-- 标题 -->
        <model-title :content="title"></model-title>
        <!-- 资源简介 -->
        <div class="share-content">
            <div class="share-resource" @click="gotoInfo(shareList[0].VProductId)">
                <div class="resource-img">
                    <img v-if="shareList[0] && shareList[0].VPictureUrl" :src="shareList[0].VPictureUrl" alt="book">
                    <p v-else>暂无封面</p>
                </div>
                <div class="resource-info">
                    <div class="info-title">
                        <p>{{info.VProductName}}</p>
                        <p>{{info.VWriterName}}</p>
                    </div>
                    <div class="info-content">{{info.VProductDesc}}</div>
                </div>
            </div>
            <!-- 资源列表 -->
            <div class="share-list">
                <div class="list-item" v-for="(item,index) in shareList.slice(1)" :key="item.VProductId" @click="gotoInfo(item.VProductId)">
                    <div class="item-left">
                        <p class="bookIcon"><i class="iconfont iconshuben"></i></p>
                        <p class="left-VProductName" >{{item.VProductName}}</p>
                    </div>
                    <div class="item-right">
                        <p>{{item.VWriterName}}</p>
                        <p style="margin-left: 1rem;width: 1rem;text-align: right;">浏览次数{{item.VVisitCount ? item.VVisitCount : '0'}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ModelTitle from './../commonView/modelTitle'
export default {
    name: 'ShareList',
    components: {
      ModelTitle,
    },
    props: ['content'],
    data() {
        return {
            title: this.content.title,
            info: {},
            shareList: [],
            routePath: ''
        }
    },
    created() {
        // 根据标题判断请求
        let type = ''
        if(this.content.title == '课件'){
            type = 3;
            this.routePath = 'coursewareInfo';
        }else if(this.content.title == '文档'){
            type = 4;
            this.routePath = 'fileInfo';
        }
        this.eduDataRes(type);
    },
    methods: {
        gotoInfo (VProductId){
            this.$router.push(
                {
                    path: this.routePath,
                    query: {
                        VProductId: VProductId
                    }
                }
            )
        },
        // 课件3/文档4
        eduDataRes (type){
            this.axios.post(window.IPConfig.IP + '/tBProduct/queryAllProducts.do',
            {
                IProductType: type,
                IAuditStatut: 1,
                VSystemId: this.$store.state.user.VSystemId,
                current: '0',
                size: '8'
            }
            ).then((response) => {
                if (response.status == 200) {
                    if (response.data.status == 200) {
                        // 单条显示赋值
                        this.info = response.data.obj[0]
                        // 列表赋值
                        this.shareList = response.data.obj;
                    }
                }
            })
        }
    }
}
</script>
<style lang="stylus" scoped>
.share-box{
    /* padding .1rem */
}
/* 标题 */
.share-title{
    display flex
    justify-content space-between
    border-left 2px solid #228457
    padding-left: 0.1rem;
}
.title-sty{
    font-weight 700
}
.title-more{
    color #46454c
    cursor pointer
}
.share-content {
    padding 0 0.1rem
}
/* 资源简介 */
.share-resource{
    border-top 1px solid #efefef
    padding .1rem
    display flex
    flex-flow row nowrap
    /* align-items center */
    justify-content space-between;
    height: 1.2rem;
    overflow: hidden;
}
.resource-img{
    padding .1rem .1rem
    //background  rgba(0,176,135,0.2)
    width: 2rem;
    height: 1rem;
    line-height: .8rem;
    text-align: center;
     cursor :pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resource-img img{
  max-width: 100%;
  max-height: 100%;
}

.resource-info{
    width: 100%;
    margin-left: .3rem;
    height: 1.5rem;
    overflow: hidden;
}
.info-title{
    display flex
    justify-content space-between
    line-height 3
    border-bottom 1px solid #efefef
    margin-bottom .1rem
}
.info-content{
  line-height 2;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  word-break: break-all;
  -webkit-box-orient: vertical;
  text-indent 0.2rem;
}
/* 资源列表 */
.list-item{
    display flex
    flex-flow row nowrap
    line-height 2
    justify-content space-between
    align-items: center;
    cursor pointer
}
.list-item:hover {
    background rgba(0,176,135,.1)
}
.item-left{
    display flex
    flex-flow row nowrap
    align-items center
}
.item-right{
    display flex
    flex-flow row nowrap
}
.bookIcon{
    color #22c6b6
}
.left-VProductName{
    margin-left: .06rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/Education/commonView/shareList.vue